import UploadNewsPage from "./UploadNewsPage";

export default UploadNewsPage;
